import { useMemo } from "react";
import { useCurrencyContext } from "api/settings/currency/CurrencyProvider";
import { useUserContext } from "api/user/UserProvider";
import {
  buildDeliveryNoteDocumentData,
  buildDeliveryNoteRenderNote,
  buildDraftFromNote,
  getCurrencySymbol,
  hasLinkedColumn,
} from "utils/deliveryNoteHelper";
import useDeliveryNoteDocumentImages from "./useDeliveryNoteDocumentImages";

const useDeliveryNoteDocument = (note) => {
  const { lang } = useUserContext();
  const { currencyList } = useCurrencyContext();

  const draft = useMemo(() => buildDraftFromNote(note), [note]);
  const { template } = draft;

  const documentData = useMemo(
    () => buildDeliveryNoteDocumentData({ draft, lang }),
    [draft, lang]
  );

  const { snapshot, resolveImage, areImagesReady } =
    useDeliveryNoteDocumentImages(template);

  const currencySymbol = getCurrencySymbol({
    currencyList,
    currencyId: note.currency_id,
  });

  const documentNote = useMemo(
    () =>
      buildDeliveryNoteRenderNote({
        note: documentData,
        snapshot,
        currencySymbol,
      }),
    [documentData, snapshot, currencySymbol]
  );

  const needsCurrency = hasLinkedColumn(note.columns);

  return {
    template,
    snapshot,
    resolveImage,
    documentNote,
    isReady:
      !!snapshot &&
      areImagesReady &&
      (!needsCurrency || !!currencyList?.length),
  };
};

export default useDeliveryNoteDocument;
